import { render, staticRenderFns } from "./IconButton.vue?vue&type=template&id=957e8fb0&"
import script from "./IconButton.vue?vue&type=script&lang=js&"
export * from "./IconButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('957e8fb0')) {
      api.createRecord('957e8fb0', component.options)
    } else {
      api.reload('957e8fb0', component.options)
    }
    module.hot.accept("./IconButton.vue?vue&type=template&id=957e8fb0&", function () {
      api.rerender('957e8fb0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/atoms/IconButton.vue"
export default component.exports